import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PersistConfig } from "redux-persist";

export interface ApiHostsState {
  hosts: Record<string, string>;
  globalHost?: string;
}

export const apiHostsReducerPersistConfig: Partial<PersistConfig<ApiHostsState>> = {
  whitelist: ["hosts", "globalHost"],
};

const initialState: ApiHostsState = {
  hosts: {},
};

const apiHostsSlice = createSlice({
  name: "apiHosts",
  initialState,
  reducers: {
    setHost: (state, action: PayloadAction<{ route: string; host: string }>) => {
      state.hosts[action.payload.route] = action.payload.host;
    },
    setGlobalHost: (state, action: PayloadAction<string>) => {
      state.globalHost = action.payload;
    },
    removeHost: (state, action: PayloadAction<string>) => {
      delete state.hosts[action.payload];
    },
    removeGlobalHost: (state) => {
      state.globalHost = undefined;
    },
  },
});

export const { setHost, setGlobalHost, removeHost, removeGlobalHost } = apiHostsSlice.actions;

export default apiHostsSlice.reducer;
